"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = void 0;
const ethers_1 = require("ethers");
const thorchain_1 = require("@shapeshiftoss/thorchain");
const types_1 = require("../types");
const thor_1 = __importDefault(require("./abi/thor"));
const utils_1 = require("./utils");
const SWAP_TYPES = ['SWAP', '=', 's'];
class Parser {
    constructor(args) {
        this.abiInterface = new ethers_1.ethers.utils.Interface(thor_1.default);
        this.thorchain = new thorchain_1.Thorchain({ midgardUrl: args.midgardUrl, rpcUrl: args.rpcUrl });
        this.depositSigHash = this.abiInterface.getSighash('deposit');
        this.transferOutSigHash = this.abiInterface.getSighash('transferOut');
        // TODO: Router contract can change, use /inbound_addresses endpoint to determine current router contract
        this.routerContract = {
            mainnet: '0xC145990E84155416144C532E31f89B840Ca8c2cE',
            ropsten: '0xefA28233838f46a80AaaC8c309077a9ba70D123A',
        }[args.network];
    }
    // detect address associated with transferOut internal transaction
    getInternalAddress(inputData) {
        if (utils_1.getSigHash(inputData) !== this.transferOutSigHash)
            return;
        const result = this.abiInterface.decodeFunctionData(this.transferOutSigHash, inputData);
        const [type] = result.memo.split(':');
        if (type !== 'OUT' || type !== 'REFUND')
            return;
        return result.to;
    }
    parse(tx) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = tx.ethereumSpecific) === null || _a === void 0 ? void 0 : _a.data))
                return;
            let result;
            switch (utils_1.getSigHash(tx.ethereumSpecific.data)) {
                case this.depositSigHash:
                    result = this.abiInterface.decodeFunctionData(this.depositSigHash, tx.ethereumSpecific.data);
                    break;
                case this.transferOutSigHash: {
                    result = this.abiInterface.decodeFunctionData(this.transferOutSigHash, tx.ethereumSpecific.data);
                    break;
                }
                default:
                    return;
            }
            const [type] = result.memo.split(':');
            if (SWAP_TYPES.includes(type) || type === 'OUT') {
                return { trade: { dexName: types_1.Dex.Thor, type: types_1.TradeType.Trade, memo: result.memo } };
            }
            if (type === 'REFUND') {
                return { trade: { dexName: types_1.Dex.Thor, type: types_1.TradeType.Refund, memo: result.memo } };
            }
            return;
        });
    }
}
exports.Parser = Parser;
